import React from "react";
// import UserPanel from "../containers/UserPanel/UserPanel";

const Saved = () => {
    return (
        <div style={{ textAlign: "center" }}>This feature is coming soon!</div>
    );
};

export default Saved;
